import React from 'react';
import { useSEO } from '../hooks/useSEO';
import { Mail, MapPin } from 'lucide-react';

export default function ContactPage() {
  useSEO({
    title: 'Contact Us | PlanningSearch',
    description: 'Get in touch with PlanningSearch for support, partnership enquiries, or feedback about our UK planning application intelligence platform.',
    canonical: 'https://planningsearch.com/contact',
  });

  return (
    <div className="min-h-[calc(100vh-56px)] bg-white" data-testid="contact-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="mb-12">
          <p className="text-xs font-semibold uppercase tracking-[0.1em] text-emerald-600 mb-2">Contact</p>
          <h1 className="font-['Manrope'] text-3xl sm:text-4xl font-extrabold tracking-tight text-zinc-900 mb-4">
            We'd love to hear from you
          </h1>
          <p className="text-base text-zinc-500 leading-relaxed">
            Whether you have a question about features, pricing, or anything else — our team is here to help.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div className="p-6 bg-zinc-50 border border-zinc-100 rounded-lg">
            <div className="w-9 h-9 bg-emerald-50 rounded-md flex items-center justify-center mb-4">
              <Mail className="w-4 h-4 text-emerald-700" />
            </div>
            <h3 className="font-['Manrope'] text-sm font-bold text-zinc-900 mb-2">Email Us</h3>
            <div className="space-y-2 text-sm">
              <p className="text-zinc-600">
                <span className="font-medium text-zinc-700">General:</span>{' '}
                <a href="mailto:hello@planningsearch.com" className="text-emerald-600 hover:text-emerald-700">hello@planningsearch.com</a>
              </p>
              <p className="text-zinc-600">
                <span className="font-medium text-zinc-700">Support:</span>{' '}
                <a href="mailto:support@planningsearch.com" className="text-emerald-600 hover:text-emerald-700">support@planningsearch.com</a>
              </p>
              <p className="text-zinc-600">
                <span className="font-medium text-zinc-700">Legal:</span>{' '}
                <a href="mailto:legal@planningsearch.com" className="text-emerald-600 hover:text-emerald-700">legal@planningsearch.com</a>
              </p>
            </div>
          </div>

          <div className="p-6 bg-zinc-50 border border-zinc-100 rounded-lg">
            <div className="w-9 h-9 bg-emerald-50 rounded-md flex items-center justify-center mb-4">
              <MapPin className="w-4 h-4 text-emerald-700" />
            </div>
            <h3 className="font-['Manrope'] text-sm font-bold text-zinc-900 mb-2">Office</h3>
            <p className="text-sm text-zinc-600 leading-relaxed">
              PlanningSearch Ltd<br />
              London, United Kingdom
            </p>
            <p className="text-xs text-zinc-400 mt-3">
              We typically respond within 1 business day.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
